import { render } from "./VFormGroupInputRadio.vue?vue&type=template&id=53d6e838&scoped=true&ts=true"
import script from "./VFormGroupInputRadio.vue?vue&type=script&lang=ts"
export * from "./VFormGroupInputRadio.vue?vue&type=script&lang=ts"

import "./VFormGroupInputRadio.vue?vue&type=style&index=0&id=53d6e838&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d6e838"]])

export default __exports__